import React from "react";
import DefaultAirlineImage from "../../../../Assets/Images/default-airline.png";
import "./AirlineLogo.css";

function AirlineLogos({ length, logos }) {
  if (length == 1) {
    return (
      <div className="airline-logos">
        <div className={`airline--info--logo-${length}`}>
          {logos?.map((item, id) => (
            <img
              className={`img-${length} img-${length}-${id}`}
              src={item == "" ? DefaultAirlineImage : item}
              alt=""
            />
          ))}
        </div>
      </div>
    );
  } else if (length == 2) {
    return (
      <div className="airline-logos">
        <div className={`airline--info--logo-${length}`}>
          {logos?.map((item, id) => (
            <img
              className={`img-${length} img-${length}-${id}`}
              src={item == "" ? DefaultAirlineImage : item}
              alt=""
            />
          ))}
        </div>
      </div>
    );
  } else if (length == 3) {
    return (
      <div className="airline-logos">
        <div className={`airline--info--logo-${3}`}>
          <div className="airline-info-row-parallel">
            <img
              className={`img-${3} img-${3}-${0}`}
              src={logos[0] == "" ? DefaultAirlineImage : logos[0]}
              alt=""
            />
            <img
              className={`img-${3} img-${3}-${1}`}
              src={logos[1] == "" ? DefaultAirlineImage : logos[1]}
              alt=""
            />
          </div>

          <div className="airline-info-row-parallel">
            <img
              className={`img-${3} img-${3}-${2}`}
              src={logos[2] == "" ? DefaultAirlineImage : logos[2]}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  } else if (length == 4) {
    return (
      <div className="airline-logos">
        <div className={`airline--info--logo-${length}`}>
          <div className="airline-info-row">
            <img
              className={`img-${length} img-${length}-${0}`}
              src={logos[0] == "" ? DefaultAirlineImage : logos[0]}
              alt=""
            />
            <img
              className={`img-${length} img-${length}-${1}`}
              src={logos[1] == "" ? DefaultAirlineImage : logos[1]}
              alt=""
            />
          </div>

          <div className="airline-info-row">
            <img
              className={`img-${length} img-${length}-${0}`}
              src={logos[2] == "" ? DefaultAirlineImage : logos[2]}
              alt=""
            />
            <img
              className={`img-${length} img-${length}-${1}`}
              src={logos[3] == "" ? DefaultAirlineImage : logos[3]}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AirlineLogos;
